module.exports = __webpack_public_path__ + "media/images/tmp/mag1-7fd5e740012af99a356f2b060e645a09.png";